import {ChangeDetectionStrategy, Component, input} from '@angular/core'
import {OtovoComponent} from './otovo/otovo.component'
import {IFrameSection} from '../../../../core/content/types/iframe-section.types'
import {ContentSectionComponent} from '../../../../craft/content-section/content-section.component'

@Component({
  selector: 'bgo-iframe-section',
  templateUrl: './iframe-section.component.html',
  styles: `
    :host {
      display: block;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [OtovoComponent, ContentSectionComponent],
})
export class IFrameSectionComponent {
  readonly section = input.required<IFrameSection>()
}
